(function () {
  function init() {
    var btn = document.querySelector('[data-cookie-reset]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      try { localStorage.removeItem('dcb_cookie'); } catch (e) {}
      location.reload();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
